var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_vm._v(_vm._s(this.chartProp.title))]),_c('div',{attrs:{"id":"pchart"}},[_c('apexchart',{attrs:{"type":"pie","height":"350","options":_vm.chartOptions,"series":_vm.series}})],1),_c('v-card-text')],1)}
var staticRenderFns = []

export { render, staticRenderFns }